import { Box, Checkbox, FormControlLabel, FormGroup, Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useRefinementList } from "react-instantsearch-core"

import { LCA_RATING_COLORS } from "@/constants/lcaRating"
import { sendFilterChangedEvent } from "@/utils/posthog"

import { FilterCheckboxCheckedIcon, FilterCheckboxIcon } from "./components/FilterCheckboxIcons"
import FilterSection, { CountBadge } from "./components/FilterSection"

const LCA_RATING_ORDER = ["C1", "C2", "C3", "C4", "C5", "C6", "C7"]

export default function LcaFirstLifeRatingFilter() {
  const { t } = useTranslation("items")
  const {
    items,
    refine,
    canRefine: hasRatings,
  } = useRefinementList({
    attribute: "lca_first_life_rating",
    sortBy: ["name:asc"],
    limit: 7,
  })

  const ratingItems = [...items].sort(
    (left, right) => LCA_RATING_ORDER.indexOf(left.label) - LCA_RATING_ORDER.indexOf(right.label)
  )
  const activeCount = ratingItems.filter((item) => item.isRefined).length

  if (!hasRatings) {
    return null
  }

  return (
    <FilterSection
      title={t("lca_first_life_rating")}
      activeCount={activeCount}
      trackingKey="lca_first_life_rating"
    >
      <Stack
        sx={{
          gap: 0.5,
        }}
      >
        {ratingItems.map((item) => {
          const color = LCA_RATING_COLORS[item.label] || "currentColor"

          return (
            <FormGroup key={item.label}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={item.isRefined}
                    onChange={() => {
                      sendFilterChangedEvent({
                        filterGroup: "lca_first_life_rating",
                        filterKey: String(item.value),
                        filterLabel: item.label,
                        isActive: !item.isRefined,
                        value: item.label,
                        metadata: {
                          result_count: item.count,
                        },
                      })
                      refine(item.value)
                    }}
                    size="small"
                    icon={<FilterCheckboxIcon />}
                    checkedIcon={<FilterCheckboxCheckedIcon />}
                  />
                }
                label={
                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                      alignItems: "center",
                    }}
                  >
                    <Stack
                      spacing={1}
                      direction="row"
                      sx={{
                        flexGrow: 1,
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.875rem",
                        }}
                      >
                        {item.label}
                      </Typography>
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor: color,
                        }}
                      />
                    </Stack>

                    <CountBadge value={item.count} />
                  </Stack>
                }
                sx={{
                  marginRight: 0,
                  marginLeft: "-7px",
                  "& .MuiFormControlLabel-label": {
                    width: "100%",
                  },
                }}
              />
            </FormGroup>
          )
        })}
      </Stack>
    </FilterSection>
  )
}
